import { render, staticRenderFns } from "./CustomerLeadsProspect.vue?vue&type=template&id=37f63fd6&scoped=true"
import script from "./CustomerLeadsProspect.vue?vue&type=script&lang=js"
export * from "./CustomerLeadsProspect.vue?vue&type=script&lang=js"
import style0 from "./CustomerLeadsProspect.vue?vue&type=style&index=0&id=37f63fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f63fd6",
  null
  
)

export default component.exports